<template>
  <div class="container">
    <div class="row">
      <div class="col-12 col-md-4">
        <div class="card card-custom gutter-b">
          <div class="card-header border-0 py-5">
            <h3 class="card-title align-items-start flex-column">
              <span class="card-label font-weight-bolder text-dark"
                >Business Information</span
              >
            </h3>
          </div>
          <div class="card-body pt-0">
            <div class="row">
              <div class="col-12 d-flex flex-column text-dark-75">
                <span class="font-weight-bolder my-1">Branch</span>
                <span class="font-weight-bolder font-size-h5">{{
                  current.item.MetadataObject.Application.BusinessProfile
                    .DisplayName
                }}</span>
              </div>
              <div class="col-12 d-flex flex-column text-dark-75">
                <span class="font-weight-bolder my-1">TIN</span>
                <span class="font-weight-bolder font-size-h5">{{
                  current.item.MetadataObject.Application.BusinessProfile.TIN
                }}</span>
              </div>
              <div class="col-12 d-flex flex-column">
                <span class="font-weight-bolder my-1">RDO Code</span>
                <span class="opacity-70">{{
                  current.item.MetadataObject.Application.BusinessProfile.RDO
                }}</span>
              </div>
              <div class="col-12 d-flex flex-column">
                <span class="font-weight-bolder my-1">Classification</span>
                <span class="opacity-70">{{
                  current.item.MetadataObject.Application.BusinessProfile
                    .Classification
                }}</span>
              </div>
              <div class="col-12 d-flex flex-column">
                <span class="font-weight-bolder my-1">Business Name</span>
                <span class="opacity-70">{{
                  current.item.MetadataObject.Application.BusinessProfile
                    .BusinessName
                }}</span>
              </div>
              <div class="col-12 d-flex flex-column">
                <span class="font-weight-bolder my-1">Registered Name</span>
                <span
                  v-if="
                    current.item.MetadataObject.Application.BusinessProfile
                      .Classification !== 'individual'
                  "
                  class="opacity-70"
                  >{{
                    current.item.MetadataObject.Application.BusinessProfile
                      .RegisteredName
                  }}</span
                >
                <span
                  v-if="
                    current.item.MetadataObject.Application.BusinessProfile
                      .Classification === 'individual'
                  "
                  class="opacity-70"
                  >{{
                    current.item.MetadataObject.Application.BusinessProfile
                      .BusinessFirstName
                  }}
                  {{
                    current.item.MetadataObject.Application.BusinessProfile
                      .BusinessMiddleName
                  }}
                  {{
                    current.item.MetadataObject.Application.BusinessProfile
                      .BusinessLastName
                  }}</span
                >
              </div>

              <div class="col-12 d-flex flex-column">
                <span class="font-weight-bolder my-1">Business Address</span>
                <span class="opacity-70">{{
                  current.item.MetadataObject.Application.BusinessProfile
                    .BusinessAddress
                }}</span>
              </div>
              <div class="col-12 d-flex flex-column">
                <span class="font-weight-bolder my-1"
                  >Date of Incorporation</span
                >
                <span class="opacity-70">{{
                  current.item.MetadataObject.Application.BusinessProfile
                    .DateOfIncorporation | moment("MMMM D, YYYY")
                }}</span>
              </div>
              <div class="col-12 d-flex flex-column">
                <span class="font-weight-bolder my-1">Mobile Number</span>
                <span class="opacity-70">{{
                  current.item.MetadataObject.Application.BusinessProfile
                    .AuthorizedUser.MobileNumber
                }}</span>
              </div>
              <div class="col-12 d-flex flex-column">
                <span class="font-weight-bolder my-1">Landline</span>
                <span class="opacity-70">{{
                  current.item.MetadataObject.Application.BusinessProfile
                    .AuthorizedUser.Landline
                }}</span>
              </div>
              <div class="col-12 d-flex flex-column">
                <span class="font-weight-bolder my-1">Email Address</span>
                <span class="opacity-70">{{
                  current.item.MetadataObject.Application.BusinessProfile
                    .AuthorizedUser.EmailAddress
                }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 col-md-8">
        <div class="card card-custom gutter-b">
          <div class="card-header border-0 py-5">
            <div class="d-flex align-items-center flex-lg-fill mr-5 my-1">
              <div class="d-flex flex-column text-dark-75 mr-5">
                <span class="font-weight-bolder font-size-sm">ATG Number</span>
                <span class="font-weight-bolder font-size-h3">{{
                  current.item.MetadataObject.Identifier
                }}</span>
              </div>
              <!--              <div class="d-flex align-items-center flex-wrap">-->
              <!--                <div class="d-flex align-items-center flex-lg-fill mr-5 my-1">-->
              <!--                  <span class="mr-4">-->
              <!--                    <i-->
              <!--                      class="flaticon2-crisp-icons icon-2x text-muted font-weight-bold"-->
              <!--                    ></i>-->
              <!--                  </span>-->
              <!--                  <div class="d-flex flex-column text-dark-75">-->
              <!--                    <span class="font-weight-bolder font-size-sm">Type</span>-->
              <!--                    <span-->
              <!--                      v-if="current.item.MetadataObject.Application.IsService"-->
              <!--                      class="font-weight-bolder font-size-h5"-->
              <!--                      >Service</span-->
              <!--                    >-->
              <!--                    <span-->
              <!--                      v-if="current.item.MetadataObject.Application.IsGoods"-->
              <!--                      class="font-weight-bolder font-size-h5"-->
              <!--                      >Goods</span-->
              <!--                    >-->
              <!--                  </div>-->
              <!--                </div>-->
              <!--              </div>-->
            </div>
            <div class="card-toolbar">
              <!--              <a-->
              <!--                v-if="current.item.Status === 'Approved'"-->
              <!--                class="align-self-start btn btn-sm btn-success font-weight-bolder text-uppercase mr-3"-->
              <!--                href="#"-->
              <!--                >Download Form</a-->
              <!--              >-->
              <!--              <a class="align-self-start btn btn-sm btn-info font-weight-bolder text-uppercase" href="#">Add Comment</a>-->
            </div>
          </div>
          <div class="card-body pt-0">
            <div class="d-flex">
              <div class="flex-grow-1">
                <div class="separator separator-solid mb-7"></div>
                <div class="d-flex align-items-center flex-wrap">
                  <div class="d-flex align-items-center flex-lg-fill mr-5 my-1">
                    <span class="mr-4">
                      <i
                        class="flaticon2-calendar-9 icon-2x text-muted font-weight-bold"
                      ></i>
                    </span>
                    <div class="d-flex flex-column text-dark-75">
                      <span class="font-weight-bolder font-size-sm"
                        >Submission Date</span
                      >
                      <span class="font-weight-bolder font-size-h5">{{
                        current.item.CreatedDateTime | moment("MMMM D, YYYY")
                      }}</span>
                    </div>
                  </div>
                  <div class="d-flex align-items-center flex-lg-fill mr-5 my-1">
                    <span class="mr-4">
                      <i
                        class="flaticon-globe icon-2x text-muted font-weight-bold"
                      ></i>
                    </span>
                    <div class="d-flex flex-column text-dark-75">
                      <span class="font-weight-bolder font-size-sm"
                        >Status</span
                      >
                      <span class="font-weight-bolder font-size-h5">{{
                        current.item.Status
                      }}</span>
                    </div>
                  </div>
                </div>
                <div
                  class="separator separator-solid mb-7"
                  v-if="current.item.Status === 'Approved'"
                ></div>
                <div
                  class="d-flex align-items-center flex-wrap"
                  v-if="current.item.Status === 'Approved'"
                >
                  <div
                    class="d-flex align-items-center flex-lg-fill mr-5 my-1"
                    v-for="series in current.item.MetadataObject.Series"
                    :key="series.SeriesType"
                  >
                    <span class="mr-4">
                      <i
                        class="fas fa-sort-numeric-down icon-2x text-muted font-weight-bold"
                      ></i>
                    </span>
                    <div class="d-flex flex-column text-dark-75">
                      <span class="font-weight-bolder font-size-sm">{{
                        series.SeriesType
                      }}</span>
                      <span class="font-weight-bolder font-size-h5"
                        >{{ series.RangeStart | numFormat("000000") }}
                        -
                        {{ series.RangeEnd | numFormat("000000") }}</span
                      >
                    </div>
                  </div>
                </div>
                <div class="separator separator-solid my-7"></div>
                <div>
                  <div class="d-flex justify-content-between">
                    <div class="d-flex flex-column flex-root">
                      <span class="font-weight-bolder mb-1"
                        >E-Receipt TSP Name</span
                      >
                      <span class="opacity-70">{{
                        current.item.MetadataObject.Application.Provider
                          .ProviderName
                      }}</span>
                    </div>
                    <div class="d-flex flex-column flex-root">
                      <span class="font-weight-bolder mb-1"
                        >E-Receipt TSP TIN</span
                      >
                      <span class="opacity-70"
                        >{{
                          current.item.MetadataObject.Application.Provider
                            .ProviderTin
                        }}-{{
                          current.item.MetadataObject.Application.Provider
                            .ProviderBranchCode
                        }}</span
                      >
                    </div>
                  </div>
                  <div class="d-flex justify-content-between pt-6">
                    <div class="d-flex flex-column flex-root">
                      <span class="font-weight-bolder mb-1"
                        >E-Receipt TSP Accreditation Number</span
                      >
                      <span class="opacity-70">{{
                        current.item.MetadataObject.Application.Provider
                          .ProviderAccreditationNumber
                      }}</span>
                    </div>
                    <div class="d-flex flex-column flex-root">
                      <span class="font-weight-bolder mb-1"
                        >Date of Accreditation</span
                      >
                      <span class="opacity-70">{{
                        current.item.MetadataObject.Application.Provider
                          .ProviderDateOfAccreditation | moment("MMMM D, YYYY")
                      }}</span>
                    </div>
                  </div>
                  <div class="d-flex justify-content-between pt-6">
                    <div class="d-flex flex-column flex-root">
                      <span class="font-weight-bolder mb-1"
                        >E-Receipt TSP Business Address</span
                      >
                      <span class="opacity-70">{{
                        current.item.MetadataObject.Application.Provider
                          .ProviderAddress
                      }}</span>
                    </div>
                  </div>
                </div>
                <div class="separator separator-solid my-7"></div>
                <div>
                  <div
                    class="d-flex justify-content-between"
                    v-if="current.item.MetadataObject.Reason !== ''"
                  >
                    <div class="d-flex flex-column flex-root">
                      <span class="font-weight-bolder mb-1"
                        >Reject/Revoke Reason</span
                      >
                      <span class="opacity-70 text-danger">{{
                        current.item.MetadataObject.Reason
                      }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="card card-custom">
          <div class="card-header align-items-center px-4 py-3">
            <div class="text-center flex-grow-1">
              <div class="text-dark-75 font-weight-bold font-size-h5">
                Messages
              </div>
            </div>
            <div class="card-toolbar">
              <button
                ref="refresh"
                :disabled="isBusy"
                class="btn btn-light font-weight-bolder font-size-sm mx-1"
                @click="getMessages"
              >
                <i class="flaticon2-refresh"></i>
              </button>
            </div>
          </div>
          <div class="card-body">
            <div class="scroll scroll-pull" data-mobile-height="350">
              <div class="messages">
                <div
                  v-for="message in messages.data"
                  :key="message.MessageId"
                  :class="{
                    'align-items-start': !message.IsCurrentUser,
                    'align-items-end': message.IsCurrentUser
                  }"
                  class="d-flex flex-column mb-5"
                >
                  <div class="d-flex align-items-center">
                    <div>
                      <span
                        v-if="message.IsCurrentUser"
                        class="text-dark-75 text-hover-primary font-weight-bold font-size-sm"
                        >You</span
                      >
                      <span
                        v-if="!message.IsCurrentUser"
                        class="text-dark-75 text-hover-primary font-weight-bold font-size-sm"
                        >{{ message.SenderDisplayName }}</span
                      >
                      <span class="text-muted font-size-sm ml-5">{{
                        message.CreatedDateTime | moment("from")
                      }}</span>
                    </div>
                  </div>
                  <div
                    class="mt-2 rounded p-5 text-dark-50 text-left max-w-400px"
                    :class="{
                      'bg-light-success': !message.IsCurrentUser,
                      'bg-light-primary': message.IsCurrentUser
                    }"
                  >
                    {{ message.Message }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="card-footer align-items-center">
            <div class="d-flex align-items-center justify-content-center">
              <textarea
                v-model="messages.newmessage"
                class="form-control border-0 p-0"
                placeholder="Type a message"
                rows="2"
              ></textarea>
              <div>
                <button
                  ref="addnote"
                  class="btn btn-primary btn-md text-uppercase font-weight-bold chat-send py-2 px-6"
                  type="button"
                  @click="createNote"
                >
                  Send
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import ApiService from "@/view/pages/easyreceipt/api";
import Vue from "vue";
import numeral from "numeral";
import numFormat from "vue-filter-number-format";

Vue.use(require("vue-moment"));
Vue.filter("numFormat", numFormat(numeral));

export default {
  components: {},
  props: {
    id: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      isBusy: false,
      tabIndex: 0,
      current: {
        item: {
          ATGId: "",
          BusinessId: "",
          RDO: "",
          Identifier: "",
          Status: "",
          MetadataObject: {
            ATGId: "",
            BusinessId: "",
            Identifier: "",
            RangeStart: "",
            RangeEnd: "",
            Status: "",
            Business: {
              Profiles: [
                {
                  ProfileId: "",
                  DisplayName: "",
                  Classification: "",
                  TIN: "",
                  BranchCode: "",
                  RDO: "",
                  TaxType: "",
                  BusinessName: "",
                  RegisteredName: "",
                  BusinessFirstName: "",
                  BusinessMiddleName: "",
                  BusinessLastName: "",
                  DateOfIncorporation: "",
                  LineOfBusiness: "",
                  BusinessAddress: "",
                  ShortName: "",
                  IsPrimary: false,
                  AuthorizedUser: {
                    FirstName: "",
                    MiddleName: "",
                    LastName: "",
                    EmailAddress: "",
                    MobileNumber: "",
                    Landline: ""
                  }
                }
              ]
            },
            Application: {
              Provider: {
                ProviderId: "",
                ProviderName: "",
                ProviderTin: "",
                ProviderBranchCode: "",
                ProviderAccreditationNumber: "",
                ProviderDateOfAccreditation: "",
                ProviderAddress: ""
              },
              BusinessProfile: {
                ProfileId: "",
                DisplayName: "",
                Classification: "",
                TIN: "",
                BranchCode: "",
                RDO: "",
                TaxType: "",
                BusinessName: "",
                RegisteredName: "",
                BusinessFirstName: "",
                BusinessMiddleName: "",
                BusinessLastName: "",
                DateOfIncorporation: "",
                LineOfBusiness: "",
                BusinessAddress: "",
                ShortName: "",
                IsPrimary: false,
                AuthorizedUser: {
                  FirstName: "",
                  MiddleName: "",
                  LastName: "",
                  EmailAddress: "",
                  MobileNumber: "",
                  Landline: ""
                }
              },
              IsService: false,
              IsGoods: false
            },
            History: [
              {
                Status: "",
                Username: "",
                ModifiedDateTime: ""
              }
            ],
            Series: []
          },
          IsActive: true,
          CreatedBy: "",
          CreatedDateTime: "",
          LastModifiedBy: "",
          LastModifiedDateTime: ""
        }
      },
      messages: {
        data: [],
        newmessage: ""
      }
    };
  },
  computed: {
    ...mapGetters(["currentUser"])
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.getData(this.id)
        .then(data => {
          this.getMessages();
          this.setBreadcrumbs(data.Identifier);
        })
        .catch();
    },
    setBreadcrumbs(value) {
      let payload = [
        {
          title: "Authority to Generate",
          route: "/easyreceipt"
        },
        {
          title: "ATG Applications",
          route: "/easyreceipt/applications"
        }
      ];
      payload.push({ title: value });
      this.$store.dispatch(SET_BREADCRUMB, payload);
    },
    getData(id) {
      this.isBusy = true;
      let self = this;
      return new Promise((resolve, reject) => {
        let param = { Id: id };
        ApiService.get("easyreceipt/getbyid", param)
          .then(({ data }) => {
            self.current.item = data;
            self.isBusy = false;
            resolve(data);
          })
          .catch(({ response }) => {
            reject(response);
          });
      });
    },
    getMessages() {
      this.isBusy = true;
      let self = this;
      return new Promise((resolve, reject) => {
        let param = { ATGId: self.current.item.ATGId };
        ApiService.get("message/getbyatgid", param)
          .then(({ data }) => {
            self.messages.data = data;
            self.isBusy = false;
            resolve(data);
          })
          .catch(({ response }) => {
            reject(response);
          });
      });
    },
    createNote() {
      this.isBusy = true;
      let self = this;
      if (self.messages.newmessage === "") return;
      return new Promise((resolve, reject) => {
        const submitButton = self.$refs["addnote"];
        submitButton.classList.add("spinner", "spinner-light", "spinner-right");
        let param = {
          ATGId: self.current.item.ATGId,
          Message: self.messages.newmessage
        };
        ApiService.put("message/create", param)
          .then(({ data }) => {
            self.isBusy = false;
            this.getMessages();
            self.messages.newmessage = "";
            submitButton.classList.remove(
              "spinner",
              "spinner-light",
              "spinner-right"
            );
            resolve(data);
          })
          .catch(({ response }) => {
            submitButton.classList.remove(
              "spinner",
              "spinner-light",
              "spinner-right"
            );
            reject(response);
          });
      });
    }
  },
  watch: {}
};
</script>
